import * as Account from './Account'
export interface ISolarAccount extends Account.IAccount {
  Escalator: number;
}

export class SolarAccount extends Account.Account implements ISolarAccount {
  Escalator: number;
}
